import { smoothCornersIndividual } from "apparatus/draw";
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
const CLAMP_BLUE = "#525d9d";
const SCREW_WIDTH = 6;
const SCREW_COLOR = "#d2d2d2";
/**
 * https://cpc.farnell.com/productimages/large/en_GB/TL12307-40.jpg
 *
 */
export class GClamp {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 20, maxX: 20,
                minY: 0,
                maxY: a => a.size,
                fromAppearance: a => P(20, a.clamping * a.size),
                toAppearance: (f, p, a) => f({ clamping: p.y / a.size }),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const { size, clamping } = appearance;
        const frame = new Path(Segments([[7, 0], [-8, 0], [2, -7]], [[-32, -20], [20, 1], [-7, 0]], [[-57, -9], [6, -11], [-8, 14]], 
        // Bottom part
        [[-57, size + 14], [-8, -19], [3, 7]], [[-40, size + 28], [-8, 0], [20, 0]], [[-8, size + 22]], [[7, size + 22]], [[7, size + 8]], // Top part of bottom lip
        [[-38, size + 8]], [[-38, -1]], [[-9, -1]], [[-8, 0]]))
            .close()
            .withStroke("default")
            .withFill(CLAMP_BLUE);
        smoothCornersIndividual(frame, {
            6: 3, // Bottom lip
            7: 3,
            8: 5, // Inner bend
            9: 5,
        });
        // Create the screw part, as a group with multiple parts
        const screw = new Path.Rectangle(R(0, 0, SCREW_WIDTH, size + 40, Pivot.TOP_CENTER), 2);
        const screwOutline = screw.clone().withStroke("default");
        screw.withFill(SCREW_COLOR);
        const handle = new Path.Rectangle(R(0, size + 33, 60, 5, Pivot.BOTTOM_CENTER), 2.0)
            .withFill(SCREW_COLOR)
            .withStroke("default");
        const screwGroup = new Group([handle, screw]);
        // Add corkscrew lines
        const screwHalfRadius = SCREW_WIDTH / 2;
        for (let y = 5; y < size + 30; y += 5) {
            const line = new Path.Line(P(-screwHalfRadius, y), P(screwHalfRadius, y + 3))
                .withStroke(2.0, SCREW_COLOR.color().darken(0.2).hex());
            screwGroup.addChildren([line]);
        }
        screwGroup.addChild(screwOutline);
        // Add the clamping pad
        const pad = (new Path(Segments([[-SCREW_WIDTH / 2, 5]], [[-SCREW_WIDTH / 2 - 5, 0]]))
            .mirrorX()
            .withStroke("default")
            .withFill(SCREW_COLOR)
            .close());
        screwGroup.addChild(pad);
        // Move the screw into position
        screwGroup.withPositionDelta({ y: clamping * size });
        const graphic = new Group([screwGroup, frame]);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: P(0, 0),
        };
    }
}
GClamp.properties = {
    label: "G-clamp",
    flippable: true,
    defaultAppearance: {
        size: 60,
        clamping: 0.5,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 50, max: 100,
        },
        {
            spec: "slider", key: "clamping", label: "Clamping", // TODO: Clamping?
            min: 0, max: 1, step: 0.01
        },
    ]
};
